import {Model} from 'vue-mc'

export default class PageContent extends Model {
  defaults() {
    return {
      name: "",
      content: ""
    }
  }

  htmlContent() {
    return this.content.replace(/(?:\r\n|\r|\n)/g, '<br>')
  }

  async show(name) {
    let request = await this.createRequest({
      method: 'GET',
      url: `/api/v2/pages/${name}`
    }).send()

    if(request.response.data.page) {
      return request.response.data.page
    }
    return {}
  }
}
